// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-container {
  padding: 20px;
  max-width: 1700px;
  margin: auto;
}

.client-heading {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center; 
}

.client-form {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 20px;
}

.form-group {
  flex: 1 1;
  margin-bottom: 20px;
}

.form-group:last-child {
  margin-right: 0;
}

.form-background {
  background-color: #A5D6A7;
  border-radius: 10px;
  padding: 20px;
  width: 97.3%;
  margin-left: 22px;
}

.client-input {
  width: 93%;
  padding: 8px;
  font-size: 16px;
  margin-top: 5px;
  border: 2px solid;
  border-radius: 10px;
  margin-right: 10px;
}

.feedback-input {
  width: 20% !important;
  padding: 8px;
  font-size: 16px;
  margin-top: 5px;
  border: 2px solid;
  border-radius: 10px;
  margin-right: 10px;
}

.wide-input {
  width: 93%;
}

.select-input {
  border: 2px solid black;
  border-radius: 10px;
  padding: 8px;
  width: 97%;
}

.client-textarea {
  width: 98%;
  padding: 8px;
  font-size: 16px;
  border: 2px solid black;
  border-radius: 10px; 
}

.client-textarea-large {
  min-height: 130px;
  width: 98.5%;
}

.update-button,
.toggle-button, 
.create-diet-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  display: inline-block; 
  text-align: center;
  font-weight: bold; 
  border-radius: 20px; 
  transition: background-color 0.3s;
}

.update-button {
  background-color: #004D40;
  color: white;
  border: none;
  margin: auto; 
}

.create-diet-button {
  background-color: #e88905;
  color: white;
  border: none;
  margin: auto;
  width: 150px;
}

.update-button:hover, 
.create-diet-button:hover {
  background-color: #ffffff; 
  color: #004D40; 
  border: 2px solid #004D40; 
}

.toggle-button {
  background-color: #dc3545;
  color: white;
  border: none;
  width: 200px;  
  height: 45px; 
  margin: 20px auto 0; 
  margin-right: 0;
}

.update-weight-btn {
  background-color: #FFA500;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  border-radius: 20px;
  transition: background-color 0.3s;
  margin-top: 10px;
  margin-bottom: 25px;
}

.update-weight-btn:hover {
  background-color: #2673ef;
  color: #ffffff;
  border: 2px solid #004D40;
}

.success-message-container {
  position: fixed;
  top: 70px; 
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; 
}

.success-message4 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message4 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}

.weight-update-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

#updated_weight {
  width: 20%;
  text-align: center;
}

.weight-history-table {
  width: 1350px !important;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 16px;
  text-align: left;
  background: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 25px;
  width: 1100px;
}

.weight-history-table thead {
  background-color: #4CAF50;
  color: white;
}

.weight-history-table th, 
.weight-history-table td {
  padding: 12px 15px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.weight-history-table tbody tr:hover {
  background-color: #f1f1f1;
}

.weight-history-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.weight-history-table .no-data,
.no-data {
  text-align: center;
  font-style: italic;
  color: #888;
}

.weight-history-graph {
  width: 100%;
  max-width: 700px; 
  margin: 20px auto;
  padding: 15px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
}  

.no-history {
  text-align: center;
  font-size: 1rem;
  color: #111;
  margin-top: 20px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #FFA500;
}

input:focus + .slider {
  box-shadow: 0 0 1px #FFA500;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.diet-toggle-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px 0;
}

.diet-type-heading {
  margin-bottom: 15px;
  font-size: 1.2rem;
  font-weight: 600;
  font-size: 28px;
}

.segmented-control {
  display: flex;
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  padding: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 430px;
}

.segment {
  flex: 1 1;
  padding: 12px 16px;
  text-align: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  color: #555;
  transition: all 0.2s ease-in-out;
  margin: 0 3px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.segment-active {
  flex: 1 1;
  padding: 12px 16px;
  text-align: center;
  border: none;
  background-color:#004D40;
  color: white;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  margin: 0 3px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.segment:focus, .segment-active:focus {
  outline: none;
}

.segment::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.4) 10%, transparent 10.01%);
  background-repeat: no-repeat;
  background-position: 50%;
  transform: scale(10, 10);
  opacity: 0;
  transition: transform 0.5s, opacity 0.8s;
}

.segment:active::after {
  transform: scale(0, 0);
  opacity: 0.3;
  transition: 0s;
}

.segment:hover:not(.segment-active) {
  background-color: rgba(0, 0, 0, 0.04);
  color: #333;
}

@media (max-width: 520px) {
  .segmented-control {
    max-width: 95%;
  }
  
  .segment, .segment-active {
    padding: 10px 8px;
    font-size: 0.85rem;
  }
}

.diet-type-label {
  font-size: 28px;
  font-weight: bold;
}

.diet-type-active-regular {
  color: #1B5E20;
}

.diet-type-active-detox {
  color: #FFA500;
}

.diet-type-inactive {
  color: #777;
}

.diet-history-container {
  margin-top: 30px;
}

.diet-history-heading {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
}

.action-buttons {
  display: flex;
  gap: 4px;
  margin-top: 4px;
  justify-content: space-between;
}

.action-button {
  padding: 6px 12px;
  margin: 0 2px;
  border-radius: 5px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  transition: all 0.2s ease;
  color: white;
  margin-top: -10px;
}

.action-use {
  background-color: #4CAF50 !important;
}

.action-view {
  background-color: #2196F3;
}

.action-edit {
  background-color: #FF9800 !important;
}

.action-delete {
  background-color: #F44336 !important;
}

.action-button:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.2);
}

.action-button:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

.feedback-column {
  width: 300px;
  max-width: 300px; 
  word-wrap: break-word; 
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background-color: #A5D6A7;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.delete-modal h3 {
  margin-top: 0;
  color: #d32f2f;
  font-size: 1.3rem;
}

.delete-modal p {
  margin: 15px 0 25px;
  color: #555;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.modal-cancel {
  background-color: #f0f0f0;
  color: #333;
}

.modal-cancel:hover {
  background-color: #e0e0e0;
}

.modal-confirm {
  background-color: #d32f2f;
  color: white;
}

.modal-confirm:hover {
  background-color: #b71c1c;
}`, "",{"version":3,"sources":["webpack://./src/styles/ClientDetailsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oBAAoB;EACpB,2FAA2F;EAC3F,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".client-container {\n  padding: 20px;\n  max-width: 1700px;\n  margin: auto;\n}\n\n.client-heading {\n  font-size: 24px;\n  margin-bottom: 20px;\n  text-align: center; \n}\n\n.client-form {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.form-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.form-group {\n  flex: 1;\n  margin-bottom: 20px;\n}\n\n.form-group:last-child {\n  margin-right: 0;\n}\n\n.form-background {\n  background-color: #A5D6A7;\n  border-radius: 10px;\n  padding: 20px;\n  width: 97.3%;\n  margin-left: 22px;\n}\n\n.client-input {\n  width: 93%;\n  padding: 8px;\n  font-size: 16px;\n  margin-top: 5px;\n  border: 2px solid;\n  border-radius: 10px;\n  margin-right: 10px;\n}\n\n.feedback-input {\n  width: 20% !important;\n  padding: 8px;\n  font-size: 16px;\n  margin-top: 5px;\n  border: 2px solid;\n  border-radius: 10px;\n  margin-right: 10px;\n}\n\n.wide-input {\n  width: 93%;\n}\n\n.select-input {\n  border: 2px solid black;\n  border-radius: 10px;\n  padding: 8px;\n  width: 97%;\n}\n\n.client-textarea {\n  width: 98%;\n  padding: 8px;\n  font-size: 16px;\n  border: 2px solid black;\n  border-radius: 10px; \n}\n\n.client-textarea-large {\n  min-height: 130px;\n  width: 98.5%;\n}\n\n.update-button,\n.toggle-button, \n.create-diet-button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-block; \n  text-align: center;\n  font-weight: bold; \n  border-radius: 20px; \n  transition: background-color 0.3s;\n}\n\n.update-button {\n  background-color: #004D40;\n  color: white;\n  border: none;\n  margin: auto; \n}\n\n.create-diet-button {\n  background-color: #e88905;\n  color: white;\n  border: none;\n  margin: auto;\n  width: 150px;\n}\n\n.update-button:hover, \n.create-diet-button:hover {\n  background-color: #ffffff; \n  color: #004D40; \n  border: 2px solid #004D40; \n}\n\n.toggle-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  width: 200px;  \n  height: 45px; \n  margin: 20px auto 0; \n  margin-right: 0;\n}\n\n.update-weight-btn {\n  background-color: #FFA500;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  border-radius: 20px;\n  transition: background-color 0.3s;\n  margin-top: 10px;\n  margin-bottom: 25px;\n}\n\n.update-weight-btn:hover {\n  background-color: #2673ef;\n  color: #ffffff;\n  border: 2px solid #004D40;\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px; \n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; \n}\n\n.success-message4 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message4 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}\n\n.weight-update-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n#updated_weight {\n  width: 20%;\n  text-align: center;\n}\n\n.weight-history-table {\n  width: 1350px !important;\n  border-collapse: collapse;\n  margin-top: 20px;\n  font-size: 16px;\n  text-align: left;\n  background: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 25px;\n  width: 1100px;\n}\n\n.weight-history-table thead {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.weight-history-table th, \n.weight-history-table td {\n  padding: 12px 15px;\n  text-align: center;\n  border-bottom: 1px solid #ddd;\n}\n\n.weight-history-table tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.weight-history-table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.weight-history-table .no-data,\n.no-data {\n  text-align: center;\n  font-style: italic;\n  color: #888;\n}\n\n.weight-history-graph {\n  width: 100%;\n  max-width: 700px; \n  margin: 20px auto;\n  padding: 15px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n}  \n\n.no-history {\n  text-align: center;\n  font-size: 1rem;\n  color: #111;\n  margin-top: 20px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 34px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #FFA500;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #FFA500;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n.diet-toggle-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 24px 0;\n}\n\n.diet-type-heading {\n  margin-bottom: 15px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  font-size: 28px;\n}\n\n.segmented-control {\n  display: flex;\n  background-color: white;\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 4px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  width: 100%;\n  max-width: 430px;\n}\n\n.segment {\n  flex: 1;\n  padding: 12px 16px;\n  text-align: center;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #555;\n  transition: all 0.2s ease-in-out;\n  margin: 0 3px;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.segment-active {\n  flex: 1;\n  padding: 12px 16px;\n  text-align: center;\n  border: none;\n  background-color:#004D40;\n  color: white;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: all 0.2s ease-in-out;\n  margin: 0 3px;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.segment:focus, .segment-active:focus {\n  outline: none;\n}\n\n.segment::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.4) 10%, transparent 10.01%);\n  background-repeat: no-repeat;\n  background-position: 50%;\n  transform: scale(10, 10);\n  opacity: 0;\n  transition: transform 0.5s, opacity 0.8s;\n}\n\n.segment:active::after {\n  transform: scale(0, 0);\n  opacity: 0.3;\n  transition: 0s;\n}\n\n.segment:hover:not(.segment-active) {\n  background-color: rgba(0, 0, 0, 0.04);\n  color: #333;\n}\n\n@media (max-width: 520px) {\n  .segmented-control {\n    max-width: 95%;\n  }\n  \n  .segment, .segment-active {\n    padding: 10px 8px;\n    font-size: 0.85rem;\n  }\n}\n\n.diet-type-label {\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.diet-type-active-regular {\n  color: #1B5E20;\n}\n\n.diet-type-active-detox {\n  color: #FFA500;\n}\n\n.diet-type-inactive {\n  color: #777;\n}\n\n.diet-history-container {\n  margin-top: 30px;\n}\n\n.diet-history-heading {\n  text-align: center;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 16px;\n  color: #333;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 4px;\n  margin-top: 4px;\n  justify-content: space-between;\n}\n\n.action-button {\n  padding: 6px 12px;\n  margin: 0 2px;\n  border-radius: 5px;\n  border: none;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n  transition: all 0.2s ease;\n  color: white;\n  margin-top: -10px;\n}\n\n.action-use {\n  background-color: #4CAF50 !important;\n}\n\n.action-view {\n  background-color: #2196F3;\n}\n\n.action-edit {\n  background-color: #FF9800 !important;\n}\n\n.action-delete {\n  background-color: #F44336 !important;\n}\n\n.action-button:hover {\n  opacity: 0.9;\n  transform: translateY(-2px);\n  box-shadow: 0 3px 6px rgba(0,0,0,0.2);\n}\n\n.action-button:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0,0,0,0.2);\n}\n\n.feedback-column {\n  width: 300px;\n  max-width: 300px; \n  word-wrap: break-word; \n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delete-modal {\n  background-color: #A5D6A7;\n  padding: 25px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.delete-modal h3 {\n  margin-top: 0;\n  color: #d32f2f;\n  font-size: 1.3rem;\n}\n\n.delete-modal p {\n  margin: 15px 0 25px;\n  color: #555;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modal-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.modal-cancel {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.modal-cancel:hover {\n  background-color: #e0e0e0;\n}\n\n.modal-confirm {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.modal-confirm:hover {\n  background-color: #b71c1c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
